import {defineStore} from "pinia";

export const useAppLoadingStore = defineStore({
    id: 'appLoading',
    state: () => {
        return {
            loading: false as boolean
        }
    },
    actions: {
        toggleLoading(): void {
            this.loading = !this.loading
        },
        setLoading(): void {
            this.loading = true
        },
        unsetLoading(): void {
            this.loading = false
        }
    },
    getters: {
        isLoading(): boolean{
            return this.loading
        }
    }
})
